import { render, staticRenderFns } from "./ApplicationPurchaseFlowResult.vue?vue&type=template&id=13af4bc6&scoped=true&"
import script from "./ApplicationPurchaseFlowResult.vue?vue&type=script&lang=js&"
export * from "./ApplicationPurchaseFlowResult.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationPurchaseFlowResult.vue?vue&type=style&index=0&id=13af4bc6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13af4bc6",
  null
  
)

export default component.exports